import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=d8c8e690&scoped=true&"
var script = {}
import style0 from "./PDFViewer.vue?vue&type=style&index=0&id=d8c8e690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c8e690",
  null
  
)

export default component.exports